import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

export const ResolvedInlineCommentsCounterLoader: LoadableType<{
	contentId: string | undefined;
}> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ResolvedInlineCommentsCounter" */ '../src/ResolvedInlineCommentsCounter.tsx'
			)
		).ResolvedInlineCommentsCounter,
});
